// Builder del parámetro `search` de los endpoints de lista de Qualita.
//
// VERIFICADO EN VIVO + CÓDIGO FUENTE (qualita-core-frontend filterFactory, 2026-06-25):
//   - El typeahead NO usa ?search=texto ni ?valor=/?query=/?descripcion=.
//   - Usa ?search=<JSON>  donde el JSON es el resultado de filterFactory.value():
//       single/and: { type:'and', filters:[ {path, like|equals|...}, ... ] }
//       or:         { type:'or',  filters:[ {type:'and',filters:[...]}, ... ] }
//   - Cada filtro hoja es { path:'campo.subcampo', like:'valor' }  (like = contiene)
//     o { path:'campo', equals:valor }.
//   - axios serializa el objeto param a query string; para reproducir el
//     JSON.stringify + encodeURIComponent que hace el front Angular, pasamos `search`
//     YA stringificado (string), y axios lo url-encodea. Así el backend recibe el JSON.
//
// Gotcha confirmado en el MT: en /productos un filtro OR que incluye el path con join
// `codigoBarrasPrincipal.codigoBarras` devuelve HTTP 500. Por eso el typeahead de
// productos usa solo paths directos (nombre, codigo). Ver productos.js.

export function and(filters) {
  return { type: 'and', filters }
}

export function or(filters) {
  return { type: 'or', filters }
}

// Devuelve el objeto params listo para axios.get(url, { params }): { search:'<json>' , ...extra }
export function searchParam(filterValue, extra = {}) {
  return { search: JSON.stringify(filterValue), ...extra }
}
